
export const getGuestExperienceEnabled = (whiteLabel) =>
    whiteLabel?.subscriber_group?.enable_guest_experience === true;

export const getCandyBarEnabled = (whiteLabel) =>
    whiteLabel?.candy_bar_items === true;

export const getSiteVersion = (whiteLabel) =>
    whiteLabel?.site_version ?? null;

export const getSiteTheme = (whiteLabel) =>
    whiteLabel?.site_theme ?? 1;

export const getReferralCodeEnabled = (whiteLabel) =>
    whiteLabel?.referral_code_flag === true;

export const getReferralPlaceholder = (whiteLabel) =>
    whiteLabel?.referral_placeholder_text ?? "Enter Referral Code";

export const isIframePaymentEnabled = (whiteLabel) =>
    whiteLabel?.enable_iframe_payment === true;
